// extracted by mini-css-extract-plugin
export default {"mobileTable":"MyTeamTable_mobileTable__XMDmw","pd":"MyTeamTable_pd__9ui8m","bg":"MyTeamTable_bg__Mntfz","title":"MyTeamTable_title__8e2RM"};